export const environment = {
  production: false,
  apiUrl: 'https://dev.conectados.camposol.com.pe',
  sapUrl: 'https://conectados-ms-update-requests-86072408712.us-east4.run.app',
  name: 'development'
};

// Dev Firebase config - used for API token generation
export const firebaseConfigDev = {
  apiKey: "AIzaSyDC_nth0IR-s7Sh4BEEvX0z_8nqsK3_yp0",
  authDomain: "csol-conectados-dev.firebaseapp.com",
  projectId: "csol-conectados-dev",
  storageBucket: "csol-conectados-dev.firebasestorage.app",
  messagingSenderId: "86072408712",
  appId: "1:86072408712:web:c5cd61313ea10c54b5bd3d"
};
